const initCollectionFinder = () => {
  const container = document.querySelector('[data-collection-finder-data]');
  if (!container) return;

  const { hierarchy } = JSON.parse(container.textContent);
  const catBtn = document.querySelector('[data-product-category]');
  const typeBtn = document.querySelector('[data-product-type]');
  const specBtn = document.querySelector('[data-product-specialism]');
  const ctaBtn = document.querySelector('[data-collection-finder-result-cta]');
  const typeOptions = document.querySelectorAll('[data-type-options-item]');
  const specOptions = document.querySelectorAll('[data-specialism-options-item]');

  if (!hierarchy.length) return;

  const ARIA_EXPANDED = 'aria-expanded';

  let currentCategoryName = hierarchy[0].category;
  catBtn.querySelector('span').textContent = currentCategoryName;

  const getCategoryData = (name) => hierarchy.find(c => c.category === name);

  // Build category list from hierarchy data (more reliable than Liquid rendering)
  const catList = document.querySelector('[data-category-options]');
  const LI_CLASS = 'text-left p-3 transition-colors duration-300 hover:bg-desert hover:text-white cursor-pointer';
  hierarchy.forEach(({ category }) => {
    if (!category) return;
    const li = document.createElement('li');
    li.dataset.categoryOptionsItem = category;
    li.className = LI_CLASS;
    li.setAttribute('role', 'option');
    li.setAttribute('tabindex', '0');
    li.textContent = category;
    catList.appendChild(li);
  });

  const updateCTA = (url) => {
    if (ctaBtn) ctaBtn.setAttribute('href', url || '#');
  };

  const resetToCategoryDefaults = (categoryName) => {
    const data = getCategoryData(categoryName);
    if (!data) return;
    typeBtn.querySelector('span').textContent = data.defaults.type_label;
    specBtn.querySelector('span').textContent = data.defaults.specialism_label;
    updateCTA(data.defaults.url);
    const validTypes = data.product_types.map(t => t.name);
    typeOptions.forEach(opt => {
      const val = opt.dataset.typeOptionsItem;
      const isVisible = validTypes.includes(val) || val === data.defaults.type_label;
      opt.style.display = isVisible ? 'block' : 'none';
    });
    specOptions.forEach(opt => {
      const val = opt.dataset.specialismOptionsItem;
      const isVisible = val === data.defaults.specialism_label;
      opt.style.display = isVisible ? 'block' : 'none';
    });
  };

  const filterSpecsByType = (typeName) => {
    const data = getCategoryData(currentCategoryName);
    if (!data) return;
    const typeData = data.product_types.find(t => t.name === typeName);

    if (!typeData) {
      resetToCategoryDefaults(currentCategoryName);
      return;
    }

    const validSpecs = typeData.specialisms.map(s => s.label);
    specOptions.forEach(opt => {
      const val = opt.dataset.specialismOptionsItem;
      opt.style.display = validSpecs.includes(val) ? 'block' : 'none';
    });

    if (typeData.specialisms.length > 0) {
      const firstSpec = typeData.specialisms[0];
      specBtn.querySelector('span').textContent = firstSpec.label;
      updateCTA(firstSpec.url);
    } else {
      specBtn.querySelector('span').textContent = data.defaults.specialism_label;
      updateCTA(data.defaults.url);
    }
  };

  const closeAll = () => {
    [catBtn, typeBtn, specBtn].forEach(b => {
      b.setAttribute(ARIA_EXPANDED, 'false');
      b.nextElementSibling.classList.add('hidden');
    });
  };

  catList.querySelectorAll('[data-category-options-item]').forEach(item => {
    item.addEventListener('click', () => {
      currentCategoryName = item.dataset.categoryOptionsItem;
      catBtn.querySelector('span').textContent = currentCategoryName;
      resetToCategoryDefaults(currentCategoryName);
      closeAll();
    });
  });

  typeOptions.forEach(item => {
    item.addEventListener('click', () => {
      typeBtn.querySelector('span').textContent = item.dataset.typeOptionsItem;
      filterSpecsByType(item.dataset.typeOptionsItem);
      closeAll();
    });
  });

  specOptions.forEach(item => {
    item.addEventListener('click', () => {
      const specName = item.dataset.specialismOptionsItem;
      specBtn.querySelector('span').textContent = specName;
      const catData = getCategoryData(currentCategoryName);
      const typeData = catData?.product_types.find(t => t.name === typeBtn.textContent.trim());
      const specData = typeData?.specialisms.find(s => s.label === specName);
      updateCTA(specData ? specData.url : catData.defaults.url);
      closeAll();
    });
  });

  [catBtn, typeBtn, specBtn].forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const isExpanded = btn.getAttribute(ARIA_EXPANDED) === 'true';
      closeAll();
      if (!isExpanded) {
        btn.setAttribute(ARIA_EXPANDED, 'true');
        btn.nextElementSibling.classList.remove('hidden');
      }
    });
  });

  document.addEventListener('click', closeAll);
  resetToCategoryDefaults(currentCategoryName);
};

export default initCollectionFinder;
